var React = require('react');

function KbdDelete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.595 14L0 8.25 5.595 2.5H16V14H5.595zM1.58 8.25l4.484 4.6h8.817v-9.2H6.064L1.58 8.25zm7.773.808L6.851 11.63l-.787-.816L8.56 8.25 6.064 5.678l.787-.808 2.502 2.564L11.85 4.87l.794.808-2.496 2.572 2.496 2.564-.794.816-2.496-2.572z"}));
}

KbdDelete.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdDelete;

KbdDelete.default = KbdDelete;
